"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

(function (window) {
  var AbstractBootstrapModal = /*#__PURE__*/function (_window$AbstractView) {
    _inherits(AbstractBootstrapModal, _window$AbstractView);

    var _super = _createSuper(AbstractBootstrapModal);

    _createClass(AbstractBootstrapModal, null, [{
      key: "SHOW_STATE",
      get: function get() {
        return "show.bs.modal";
      }
    }, {
      key: "SHOWN_STATE",
      get: function get() {
        return "shown.bs.modal";
      }
    }, {
      key: "HIDE_STATE",
      get: function get() {
        return "hide.bs.modal";
      }
    }, {
      key: "HIDDEN_STATE",
      get: function get() {
        return "hidden.bs.modal";
      }
    }, {
      key: "THEME_SUCCESS",
      get: function get() {
        return "success";
      }
    }, {
      key: "THEME_WARNING",
      get: function get() {
        return "warning";
      }
    }, {
      key: "THEME_DANGER",
      get: function get() {
        return "danger";
      }
    }]);

    function AbstractBootstrapModal(id, options) {
      var _this;

      _classCallCheck(this, AbstractBootstrapModal);

      var OPTIONS_DEFAULT = {
        modal: {
          show: false,
          // Shows the modal when initialized.
          focus: true,
          // Puts the focus on the modal when initialized.
          keyboard: false,
          // Closes the modal when escape key is pressed
          backdrop: true // Includes a modal-backdrop element. Alternatively, specify static for a backdrop which doesn't close the modal on click.

        }
      };
      options = $.extend(true, OPTIONS_DEFAULT, _.clone(options));
      _this = _super.call(this, id, options);
      _this.state = _this.options.modal.show === true ? window.AbstractBootstrapModal.SHOWN_STATE : window.AbstractBootstrapModal.HIDDEN_STATE;

      _this.$domElement.modal(_this.options.modal);

      _this.$domElement.on(window.AbstractBootstrapModal.SHOW_STATE, function (event) {
        _this.state = window.AbstractBootstrapModal.SHOW_STATE;

        _this.modalShowHandler();
      });

      _this.$domElement.on(window.AbstractBootstrapModal.SHOWN_STATE, function (event) {
        _this.state = window.AbstractBootstrapModal.SHOWN_STATE;

        _this.modalShownHandler();
      });

      _this.$domElement.on(window.AbstractBootstrapModal.HIDE_STATE, function (event) {
        _this.state = window.AbstractBootstrapModal.HIDE_STATE;

        _this.modalHideHandler();
      });

      _this.$domElement.on(window.AbstractBootstrapModal.HIDDEN_STATE, function (event) {
        _this.state = window.AbstractBootstrapModal.HIDDEN_STATE;

        _this.modalHiddenHandler();
      });

      _this.$modalContent = _this.$domElement.find(".modal-content");
      return _this;
    }

    _createClass(AbstractBootstrapModal, [{
      key: "init",
      value: function init() {
        var _this2 = this;

        this.$domElement.on("show.bs.modal." + this.id, function (event) {
          Globals.bodyScrollEnabled = false;

          _get(_getPrototypeOf(AbstractBootstrapModal.prototype), "triggerShowStart", _this2).call(_this2);
        });
        this.$domElement.on("shown.bs.modal." + this.id, function (event) {
          Globals.bodyScrollEnabled = false;

          _get(_getPrototypeOf(AbstractBootstrapModal.prototype), "triggerShowComplete", _this2).call(_this2);
        });
        this.$domElement.on("hide.bs.modal." + this.id, function (event) {
          Globals.bodyScrollEnabled = true;

          _get(_getPrototypeOf(AbstractBootstrapModal.prototype), "triggerHideStart", _this2).call(_this2);
        });
        this.$domElement.on("hidden.bs.modal." + this.id, function (event) {
          Globals.bodyScrollEnabled = true;

          _get(_getPrototypeOf(AbstractBootstrapModal.prototype), "triggerHideComplete", _this2).call(_this2);
        });

        _get(_getPrototypeOf(AbstractBootstrapModal.prototype), "init", this).call(this);
      }
    }, {
      key: "update",
      value: function update() {
        var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        //USE CAREFULLY
        this.$domElement.find(".modal-header").html(data.header ? data.header : "");
        this.$domElement.find(".modal-body").html(data.body ? data.body : "");
        this.$domElement.find(".modal-footer").html(data.footer ? data.footer : "");
        this.handleUpdate();

        _get(_getPrototypeOf(AbstractBootstrapModal.prototype), "update", this).call(this);
      }
    }, {
      key: "handleUpdate",
      value: function handleUpdate() {
        this.$domElement.modal("handleUpdate");
      }
    }, {
      key: "modalShowHandler",
      value: function modalShowHandler() {
        var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      }
    }, {
      key: "modalShownHandler",
      value: function modalShownHandler() {
        var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      }
    }, {
      key: "modalHideHandler",
      value: function modalHideHandler() {
        var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      }
    }, {
      key: "modalHiddenHandler",
      value: function modalHiddenHandler() {
        var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      }
    }, {
      key: "show",
      value: function show(data) {
        if (this.showStatus) {
          return;
        }

        if (data) {
          this.update(data);
        }

        this.$domElement.modal("show");
      }
    }, {
      key: "hide",
      value: function hide() {
        Globals.bodyScrollEnabled = true;

        if (this.hideStatus) {
          return;
        }

        this.$domElement.modal("hide");
      }
    }, {
      key: "toggle",
      value: function toggle() {
        this.$domElement.modal("toggle");
      }
    }, {
      key: "dispose",
      value: function dispose() {
        this.$domElement.off("show.bs.modal shown.bs.modal hide.bs.modal hidden.bs.modal");
        this.$modalContent = null;

        _get(_getPrototypeOf(AbstractBootstrapModal.prototype), "dispose", this).call(this);
      }
    }]);

    return AbstractBootstrapModal;
  }(window.AbstractView);

  window.AbstractBootstrapModal = AbstractBootstrapModal;
})(window);
